import { Divider, VStack, DataList } from '@cad-arc';
import { SearchPersonForm } from '@mark43/cad-api';
import { intersperse } from '../common/helpers/intersperse';
import { formatMonthDayYear } from '../common/helpers/utils';
import { FilterSummary } from '../search-windows/filter-summary';
import { FiltersSummary } from '../search-windows/filters-summary';

export function PersonInformationFiltersSummary({ persons }: { persons: SearchPersonForm[] }) {
    if (persons.length === 0) {
        return null;
    }
    return (
        <FiltersSummary title="Person Information">
            <VStack align="left" gap="2px">
                {intersperse(
                    persons.map((person, index) => (
                        <DataList key={index}>
                            <FilterSummary label="First Name" stringValue={person.firstName} />
                            <FilterSummary label="Last Name" stringValue={person.lastName} />
                            <FilterSummary label="Race" option={person.race} />
                            <FilterSummary label="Sex" option={person.sex} />
                            <FilterSummary
                                label="Date of Birth"
                                stringValue={
                                    person.dateOfBirth
                                        ? formatMonthDayYear(person.dateOfBirth)
                                        : undefined
                                }
                            />
                            <FilterSummary label="Min Age" numberValue={person.ageMin} />
                            <FilterSummary label="Max Age" numberValue={person.ageMax} />
                            <FilterSummary
                                label="Involvement Type"
                                option={person.involvementType}
                            />
                            <FilterSummary
                                label="Involvement Type Description"
                                stringValue={person.involvementTypeOther}
                            />
                            <FilterSummary label="DL #" stringValue={person.driversLicenseNumber} />
                            <FilterSummary label="DL State" option={person.driversLicenseState} />
                            <FilterSummary label="SSN" stringValue={person.socialSecurityNumber} />
                            <FilterSummary label="Notes" stringValue={person.notes} />
                            <FilterSummary label="Height" stringValue={person.height} />
                            <FilterSummary label="Min Height" stringValue={person.heightMin} />
                            <FilterSummary label="Max Height" stringValue={person.heightMax} />
                            <FilterSummary label="Weight" numberValue={person.weight} />
                            <FilterSummary label="Min Weight" numberValue={person.weightMin} />
                            <FilterSummary label="Max Weight" numberValue={person.weightMax} />
                            <FilterSummary label="Eye Color" option={person.eyeColor} />
                            <FilterSummary label="Hair Color" option={person.hairColor} />
                            <FilterSummary label="Phone" stringValue={person.phoneNumber} />
                            <FilterSummary label="Ext." stringValue={person.phoneExtension} />
                        </DataList>
                    )),
                    <Divider />
                )}
            </VStack>
        </FiltersSummary>
    );
}
